module.exports = __webpack_public_path__ + "static/img/service-h5-6.e3a38fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-6.png
// module id = 5Et0
// module chunks = 34